export default {
    "iot-alert-mgmt.10001": "无效的告警规则",
    "iot-alert-mgmt.10002": "规则名称已存在",
    "iot-alert-mgmt.10003": "无效的告警规则状态",
    "iot-alert-mgmt.10004": "告警规则不存在",
    "iot-alert-mgmt.10005": "Elasticsearch error",
    "iot-alert-mgmt.10006": "告警规则的规则类型无效",
    "iot-alert-mgmt.10007": "边缘计算规则名称重复",
    "iot-alert-mgmt.10008": "该边缘计算规则不存在",
    "iot-alert-mgmt.10009": "边缘计算规则下发历史不存在",
    "iot-alert-mgmt.10010": "边缘计算规则下发数据不存在",
    "iot-alert-mgmt.10011": "can not find specification for tenant[id={0}]",
    "iot-alert-mgmt.10012": "新增规则失败，超出规则数量",
    "iot-alert-mgmt.10013": "things forward rule[id={0}] is not exist",
    "iot-alert-mgmt.10014": "things select size is 0",
    "iot-alert-mgmt.10015": "保存规则失败，规则名称重复",
    "iot-alert-mgmt.10016": "Update alert rule error, alert type cannot be changed.",
    "iot-alert-mgmt.10017": "Twins rule is not exist ",
    "iot-alert-mgmt.10019": "保存告警规则失败，告警条件最大长度为65,535",
}